"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 48 48" },
  React.createElement("path", { d: "M15.773 36.675a.272.272 0 0 0-.357-.338c-.927.362-2.337.774-2.946.165-1.924-1.924 1.875-9.793 8.189-16.107s14.257-9.861 16.1-8.02a1.372 1.372 0 0 1 .318 1.276.277.277 0 0 0 .355.314 11.41 11.41 0 0 1 1.887-.412.53.53 0 0 0 .462-.478 2.834 2.834 0 0 0-.636-2.39l-.023-.021.007-.008A20.127 20.127 0 1 0 10.3 38.715a1.059 1.059 0 0 0 .158.131l.013.014a2.631 2.631 0 0 0 1.933.668 8.2 8.2 0 0 0 2.542-.5.573.573 0 0 0 .377-.455 14.352 14.352 0 0 1 .45-1.898z" }),
  React.createElement("path", { d: "M43.545 19.976c-.37-2.234-1.185-3.733-3.166-3.733-3.394 0-8.84 3.432-13.875 8.741-5.976 6.3-9.421 13.123-8.375 16.583a3.458 3.458 0 0 0 3.1 2.381 18.138 18.138 0 0 0 2.8.217 18.855 18.855 0 0 0 13.879-5.986 20.135 20.135 0 0 0 5.637-18.203z" })
);

